import {
  Anchor,
  Container,
  Flex,
  Group,
  Stack,
  Text,
  useComputedColorScheme,
} from "@mantine/core";
import { SvgLogoBlack, SvgLogoWhite } from "./SvgLogo";

export const Footer = () => {
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });
  return (
    <Group bg={computedColorScheme === "dark" ? "#6E7176" : "#F5F6FE"} grow>
      <Container py="xl">
        <Group grow>
          <Stack>
            {computedColorScheme === "dark" ? (
              <Anchor href="https://solidstudio.io/" target="_blank">
                <SvgLogoWhite width="113" />
              </Anchor>
            ) : (
              <Anchor href="https://solidstudio.io/" target="_blank">
                <SvgLogoBlack width="113" />
              </Anchor>
            )}
          </Stack>
          <Flex flex={1} />
          <Stack>
            <Text size="xs">
              <Anchor
                href="mailto:contact@solidstudio.io"
                variant="text"
                c="inherit"
              >
                contact@solidstudio.io
              </Anchor>
              <br />
              <Anchor href="tel:+48 538 365 618" variant="text" c="inherit">
                +48 538 365 618
              </Anchor>
            </Text>
          </Stack>
          <Flex flex={1} />
          <Stack>
            <Text size="xs">
              ul. Karmelicka 27/101
              <br />
              31-131 Cracow
            </Text>
          </Stack>
        </Group>
        <hr
          style={{
            height: "1px",
            color: "#E4E6EC",
            backgroundColor: "#E4E6EC",
            border: "none",
          }}
        />
        <Group grow>
          <Text size="xs" c="gray.5">
            {new Date().getFullYear()}© Copyright Solidstudio. All Rights
            Reserved
          </Text>
        </Group>
      </Container>
    </Group>
  );
};
